// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__19czA","desc":"Banner_desc__lRKTT"};